import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Trophy, Medal } from "lucide-react";
import { endpoints } from "@/lib/api";

export default function Leaderboard() {
  const [cats, setCats] = useState([]);
  const [active, setActive] = useState("");
  const [cars, setCars] = useState([]);
  useEffect(() => { endpoints.categories().then(setCats).catch(() => {}); }, []);
  useEffect(() => { endpoints.leaderboard(active ? { category_id: active } : {}).then(setCars).catch(() => {}); }, [active]);

  const rankColor = (i) => (i === 0 ? "#ffd600" : i === 1 ? "#c0c0c0" : i === 2 ? "#cd7f32" : "#8a8d91");

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2">
        <Trophy className="text-[#ffd600]" size={26} />
        <h1 className="font-display text-4xl uppercase text-white">Live Leaderboard</h1>
      </div>
      <div className="flex gap-2 overflow-x-auto no-scrollbar pb-1">
        <button onClick={() => setActive("")} className={`shrink-0 px-4 py-2 font-heading uppercase text-xs border ${active === "" ? "pas-gradient text-black border-transparent" : "border-white/15 text-white/70"}`}>Overall</button>
        {cats.map((c) => (
          <button key={c.id} onClick={() => setActive(c.id)} className={`shrink-0 px-4 py-2 font-heading uppercase text-xs border ${active === c.id ? "pas-gradient text-black border-transparent" : "border-white/15 text-white/70"}`}>{c.name}</button>
        ))}
      </div>
      <div className="space-y-2" data-testid="leaderboard-list">
        {cars.map((car, i) => (
          <Link key={car.id} to={`/app/cars/${car.id}`} className="flex items-center gap-3 border border-white/10 bg-[#121212] card-hover overflow-hidden" data-testid={`rank-${i}`}>
            <div className="font-display text-4xl w-14 text-center tabular-nums" style={{ color: rankColor(i) }}>{i + 1}</div>
            <img src={car.photo_url} alt="" className="w-20 h-16 object-cover" />
            <div className="flex-1 py-2">
              <div className="text-[#ff7a1a] font-heading text-xs uppercase">{car.category_name}</div>
              <div className="font-heading text-white uppercase leading-tight">{car.make} {car.model}</div>
            </div>
            <div className="pr-4 text-right">
              <div className="font-display text-2xl pas-gradient-text">{car.vote_count}</div>
              <div className="text-[10px] uppercase text-[#8a8d91] font-heading">votes</div>
            </div>
          </Link>
        ))}
        {cars.length === 0 && <div className="text-center text-[#8a8d91] py-10 font-heading uppercase">No votes yet</div>}
      </div>
    </div>
  );
}
